export default function cancelAnimationFrame(handler) {
  var method = window.cancelAnimationFrame || window.webkitCancelAnimationFrame ||
  // @ts-ignore
  window.mozCancelAnimationFrame ||
  // @ts-ignore
  window.msCancelAnimationFrame || clearTimeout;
  method(handler);
}
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/esm/clear-animation-frame.js
// module id = 95
// module chunks = 0